import React, { useEffect, useState, useRef } from 'react';
import {
    Box, Card, Typography, Table, TableHead, TableRow, TableCell,
    TableBody, Paper, Divider, Button
} from '@mui/material';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import Shopheader from '../Shop/Shopheader';
import Mashalheader from '../Mashal/Mashalheader';
import Wholesalerheader from '../Wholesale/Wholesaleheader';

export default function CustomerOutstandingReport() {
    const [Customers, setCustomers] = useState([]);
    const [CustomerAccounts, setCustomerAccounts] = useState({});
    const category = 'shop'; // replace with useParams() if dynamic
    const printRef = useRef();

    useEffect(() => {
        fetchCustomersAndAccounts();
    }, [category]);

    const fetchCustomersAndAccounts = async () => {
        try {
            const q = query(collection(db, 'customers'), where('category', '==', category));
            onSnapshot(q, (snap) => {
                const CustomerData = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCustomers(CustomerData);

                CustomerData.forEach(Customer => {
                    const SalesQuery = query(collection(db, 'sales'), where('customerId', '==', Customer.id));
                    onSnapshot(SalesQuery, (snapSales) => {
                        let grand = 0;
                        snapSales.docs.forEach(p => {
                            grand += parseFloat(p.data().grandTotal || 0);
                        });

                        const paymentsQuery = query(
                            collection(db, 'customerpaymenthistory'),
                            where('customerId', '==', Customer.id)
                        );
                        onSnapshot(paymentsQuery, (snapPayments) => {
                            let paid = snapPayments.docs.reduce((acc, doc) => acc + parseFloat(doc.data().amount || 0), 0);
                            const remaining = grand - paid;
                            if (remaining > 0) { // only include customers with remaining
                                setCustomerAccounts(prev => ({
                                    ...prev,
                                    [Customer.id]: {
                                        grandTotal: grand.toFixed(2),
                                        paidTotal: paid.toFixed(2),
                                        remainingTotal: remaining.toFixed(2),
                                        name: Customer.name,
                                        mobile: Customer.mobile,
                                        address: Customer.address || '-'
                                    },
                                }));
                            }
                        });
                    });
                });
            });
        } catch (error) {
            console.error(error.message);
        }
    };

    const totals = Object.values(CustomerAccounts).reduce(
        (acc, curr) => {
            acc.grandTotal += parseFloat(curr.grandTotal);
            acc.paidTotal += parseFloat(curr.paidTotal);
            acc.remainingTotal += parseFloat(curr.remainingTotal);
            return acc;
        },
        { grandTotal: 0, paidTotal: 0, remainingTotal: 0 }
    );

    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
            <html>
                <head>
                    <title>ग्राहक उधारी रिपोर्ट </title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                        th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                        th { background-color: #1976d2; color: #fff; }
                        h2,h4 { margin: 5px 0; }
                    </style>
                </head>
                <body>
                    ${content}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };

    return (
        <Box p={3} mt={10}>
            {category === "shop" && <Shopheader />}
            {category === "mashal" && <Mashalheader />}
            {category === "wholesaler" && <Wholesalerheader />}

            <Card sx={{ p: 2, mb: 2 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    ग्राहक उधारी रिपोर्ट 
                </Typography>
                <Button variant="contained" color="primary" onClick={handlePrint} sx={{ mb: 2 }}>
                    प्रिंट रिपोर्ट 
                </Button>
            </Card>

            <Box ref={printRef}>
                <Card sx={{ p: 2 }}>
                    <Paper sx={{ p: 2 , overflowX:"auto" }}>
                        <Table size="small">
                            <TableHead sx={{ backgroundColor: '#1976d2' }}>
                                <TableRow>
                                    <TableCell sx={{ color: '#fff' }}>Sr No</TableCell>
                                    <TableCell sx={{ color: '#fff' }}>ग्राहकाचे नाव </TableCell>
                                    <TableCell sx={{ color: '#fff' }}>मोबाईल </TableCell>
                                    <TableCell sx={{ color: '#fff' }}>पत्ता </TableCell>
                                    <TableCell sx={{ color: '#fff' }}>टोटल विक्री </TableCell>
                                    <TableCell sx={{ color: '#fff' }}>जमा </TableCell>
                                    <TableCell sx={{ color: '#fff' }}>बाकी </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.values(CustomerAccounts).map((cust, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{cust.name}</TableCell>
                                        <TableCell>{cust.mobile}</TableCell>
                                        <TableCell>{cust.address}</TableCell>
                                        <TableCell>₹{parseFloat(cust.grandTotal).toFixed(2)}</TableCell>
                                        <TableCell>₹{parseFloat(cust.paidTotal).toFixed(2)}</TableCell>
                                        <TableCell>₹{parseFloat(cust.remainingTotal).toFixed(2)}</TableCell>
                                    </TableRow>
                                ))}
                                {Object.values(CustomerAccounts).length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">No outstanding customers.</TableCell>
                                    </TableRow>
                                )}

                                {/* Totals */}
                                <TableRow sx={{ backgroundColor: 'rgba(25,118,210,0.1)' }}>
                                    <TableCell colSpan={4} align="right"><b>Total</b></TableCell>
                                    <TableCell><b>₹{totals.grandTotal.toFixed(2)}</b></TableCell>
                                    <TableCell><b>₹{totals.paidTotal.toFixed(2)}</b></TableCell>
                                    <TableCell><b>₹{totals.remainingTotal.toFixed(2)}</b></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Card>
            </Box>
        </Box>
    );
}
